export default {
  $nflData: {},
  $profile: {},
  $profiles: {},
  fbUserModels: {},
  fbTrackModels: {},
  isNFLApp: false
}


// WEBPACK FOOTER //
// ./src/store/states/nfl.js